var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { Badge, ClickAwayListener, IconButton, Tooltip } from '@mui/material';
import { AuctionIcon } from '../atoms/Icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
var TooltipTitle = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  white-space: pre-line;\n  word-break: break-word;\n"], ["\n  white-space: pre-line;\n  word-break: break-word;\n"])));
var TooltipWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n"], ["\n  display: inline-block;\n"])));
var AuctionIconLink = function (_a) {
    var offer = _a.offer, isRoaster = _a.isRoaster;
    var t = useTranslation().t;
    var navigate = useNavigate();
    var _b = React.useState(false), open = _b[0], setOpen = _b[1];
    var closeTimer = React.useRef();
    var handleClose = React.useCallback(function () {
        setOpen(false);
        if (closeTimer.current)
            clearTimeout(closeTimer.current);
    }, []);
    var handleOpen = React.useCallback(function () {
        setOpen(true);
        if (closeTimer.current)
            clearTimeout(closeTimer.current);
        closeTimer.current = Number(setTimeout(handleClose, 5000));
    }, [handleClose]);
    if (offer.orderType !== 'auction')
        return null;
    return (React.createElement(ClickAwayListener, { onClickAway: handleClose },
        React.createElement(TooltipWrapper, { onClick: handleOpen, onMouseEnter: handleOpen, onMouseLeave: handleClose, role: "button" },
            React.createElement(Tooltip, { open: open, title: React.createElement(TooltipTitle, null, t('pages.roasterOrder.auctionBadgeExplanation')), enterTouchDelay: 0, disableTouchListener: true, disableHoverListener: true, disableFocusListener: true },
                React.createElement("span", null,
                    React.createElement(IconButton, { disabled: !offer.auctionClosed || offer.offerList.status !== 'expired', onClick: function () {
                            return navigate("/".concat(isRoaster ? 'roaster' : 'admin', "/offer_lists/").concat(offer.offerList.id, "/auctions/").concat(offer.id));
                        }, size: "large" },
                        React.createElement(Badge, { color: "primary", badgeContent: offer.bidsRoasterCount, max: 999 },
                            React.createElement(AuctionIcon, { "aria-label": "auction" }))))))));
};
export default AuctionIconLink;
var templateObject_1, templateObject_2;
